<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando" > 
                <KDataTable :config="config" :pesquisar="false"> 
                    <th>Disciplina</th> 
                    <th>Tipo</th>
                    <th>CH</th>
                    <th>faltas</th> 
                    <th>Nota</th>
                    <!-- <th>reprovado</th>
                    <th>Status</th>   -->
                    <!-- <th>VC</th>
                    <th>VF</th>
                    <th>VR</th> -->
                </KDataTable>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts"> 
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    const authStore = namespace('auth'); 
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import MatriculaService from   "@/service/v10/sigap/MatriculaService"   
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"  
    import Multiselect from '@vueform/multiselect' 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
     
    import {  Prop  } from 'vue-property-decorator';   

    @Options({
        name: "HistoricoNotasIndex",
        components: {  CardRh , KDataTable, Multiselect  },
    }) 
    export default class HistoricoNotasIndex extends Vue {
        
        @Prop( ) readonly matricula!: any

        @authStore.Getter
        public perfis!: any
          
        public processando = false; 
        public reloadDatatable = false ;
        public config: any = null; 
        public service: any = null;    
        public matriculaId: any = null
          
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
    
        created(){    
            this.matriculaId = this.$route.params.id; 
            this.config = {  ajax: {} , columns: [] , columnDefs: [] , order: [] }; 
            this.service = new MatriculaService();  
            this.config.ajax = { 
                url: this.service.getApiUrl() + "/" + this.matriculaId + "/Historico" ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,  
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 
            this.config.dom =   "<'row'<'col-xs-12'<'col-xs-12'><'col-xs-12' >>r>" + "<'row'<'col-xs-12't>>" + "<'row'<'col-lg-3'><'col-lg-6'><'col-lg-3'i>>";
            this.config.lengthMenu =  [ [ -1], [ "Todos"] ];

            this.config.columns = [  
                { data: 'disciplina', name: 'disciplina'   },  
                { data: 'disciplinaTipo', name: 'disciplinatipo'   }, 
                { data: 'cargaHoraria', name: 'cargahoraria'   }, 
                { data: 'qteFaltas', name: 'qtefaltas'   },  
                { data: 'nota', name: 'nota'   },  
            ];
              
            this.config.columnDefs = [ 
                {
                    targets: 1,
                    render: function ( row, type, val, meta ) {  
                        return  row.nome.replaceAll('_' , ' ')  ;  
                    }
                },  
                {
                    targets: 3,
                    render: function ( row, type, val, meta ) {  
                        return  row + ' / ' + val.limiteFaltas ;  
                    }
                },  
                // {
                //     targets: 5,
                //     render: function ( row, type, val, meta ) {  
                //         return  row ? 'Sim' : 'Não' ;  
                //     }
                // },  
                {
                    targets: 4,
                    render: function ( row, type, val, meta ) {  
                        return  val.disciplinaTipo.id == 1 ? row : row >=7 ? 'Apto' : 'Inapto' ;  
                    }
                },  
            ];   
            
        }     
   
    } 
  
</script>